<template>
    <div class="page-layout blank contacts-manage">
        <div class="general-section pt-2" style="border-top-left-radius: 0px !important;">
            <div style="height: 50px;" v-if="ajaxCallinprogress && !is_ticket_details_not_found">
                <hollow-dots-spinner :animation-duration="1000" :dot-size="17" :dots-num="3" color="#00448b" class="text-center w-100 d-flex justify-content-center"/>
            </div>
            <div style="height: 50px;" v-else-if="!ajaxCallinprogress && is_ticket_details_not_found">
                <h1 class="fs-14 text-danger text-center py-3">Ticket Not Found</h1>
            </div>
            <div v-else class="">
                <div class="row pt-2 px-4">
                    <div class="d-flex align-items-start flex-column flex-sm-row col-lg-6 col-md-6 col-sm-12">
                        <div class="text-secondary fw-500 whiteSpace">Ticket #{{general_details.ticket_number}}</div>
                        <div class="text-secondary fw-500 pl-0 pl-sm-10 ticket_subject text-capitalize">{{general_details.subject}}</div>
                    </div>
                    <div class="d-flex align-items-center justify-content-start justify-content-md-between col-lg-6 col-md-6 col-sm-12 mt-3 mt-md-0 " style="width:50%;">
                        <div class="d-flex flex-nowrap text-capitalize">
                            <button style="text-transform: capitalize;" class="btn btn-smm btn-default text-white btn-success-border-radius"  
                            :class="{'btn-open-status-newtheme':general_details.status == 'Open',
                            'btn-assigned':general_details.status == 'Assigned',
                            'btn-hex-gray38':general_details.status == 'Unassigned',
                            'btn-grid-inprogress-newtheme':general_details.status == 'In progress',
                            'btn-fixed-newtheme':general_details.status == 'Fixed',
                            'btn-closed-newtheme':general_details.status == 'Closed', 
                            'btn-reopen-newtheme':general_details.status == 'Re-Open',
                            'btn-moonlight-sage':general_details.status == 'Reject', 
                            'btn-schedule':general_details.status == 'Scheduled'}">
                            {{general_details.status}}
                            </button>
                        </div>
                        <div id="clock" class="ml-3">
                            <button class="btn btn-secondary btn-smm mr-2" v-if="can_change_status && !check_if_approval_required" @click="showAllStatus()">Change Status</button>
                            <button class="btn btn-secondary btn-smm" v-if="can_edit" @click="showEditBaseTemplate()">Edit Ticket</button>
                            <button class="btn btn-secondary btn-smm" v-if="can_close_ticket && !can_edit && general_details.status == 'Fixed'" @click="closeTicket">Close Ticket</button>
                        </div>
                    </div>
                </div>
                <div class="mt-5 mb-3">
                    <div class="box-blue-header d-flex align-items-center justify-content-between p-3 box-blue-header-parent">
                        <span class="text-white fw-500 pl-1">General Details</span>
                    </div>
                    <div class="row pt-3 pl-5 pr-5 pb-2 bottom-border">
                        <div class="col-lg-6 col-md-6 col-sm-12">
                            <div class="fw-400 pt-2 pb-2 text-black d-inline-block">Assigned To :</div> <br>
                            <div class="fw-500 text-secondary d-inline-block w-100 overflowing-text text-capitalize" :title="general_details.assigned_to">
                                <span>{{general_details.assigned_to || '-'}}</span></div>
                        </div>
                        <div class="col-lg-6 col-md-6 col-sm-12">
                            <div class="fw-400 pt-2 pb-2 text-black d-inline-block">Ticket Subject :</div> <br>
                            <div class="fw-500 text-secondary d-inline-block w-100 overflowing-text text-capitalize" :title="general_details.subject">
                                <span>{{general_details.subject || '-'}}</span></div>
                        </div>
                    </div>
                    <div class="row pt-3 pl-5 pr-5 pb-2 bottom-border">
                        <div class="col-lg-6 col-md-6 col-sm-12">
                            <div class="fw-400 pt-2 pb-2 text-black d-inline-block">Author :</div> <br>
                            <div class="fw-500 text-secondary d-inline-block w-100 overflowing-text text-capitalize" :title="general_details.created_by.name">
                                <span>{{general_details.created_by.name || '-'}}</span></div>
                        </div>
                        <div class="col-lg-6 col-md-6 col-sm-12">
                            <div class="fw-400 pt-2 pb-2 text-black d-inline-block">Date and Time of Creation :</div> <br>
                            <div class="fw-500 text-secondary d-inline-block">
                                <img src="https://cdn.digicollect.com/cdn/dc_helpdesk_new/images/images-new/menu/calendar.svg" alt="">
                                <span class="ml-1">
                                    {{general_details.creation_date.date.replaceAll('-','/') || '-'}}
                                </span>
                                <img src="https://cdn.digicollect.com/cdn/dc_helpdesk_new/images/images-new/menu/clock.svg" class="ml-2" alt="">
                                <span class="ml-1">
                                    {{general_details.creation_date.time || '-'}}
                                </span>
                            </div>
                        </div>
                    </div>
                    <div class="row pt-3 pl-5 pr-5 pb-2 bottom-border">
                        <div class="col-lg-6 col-md-6 col-sm-12">
                            <div class="fw-400 pt-2 pb-2 text-black d-inline-block">Status:</div> <br>
                            <div class="fw-500 text-secondary d-inline-block w-100 overflowing-text text-capitalize">
                                <span>{{general_details.status|| '-'}}</span>
                            </div>
                        </div>
                        <div class="col-lg-6 col-md-6 col-sm-12">
                            <div class="fw-400 pt-2 pb-2 text-black d-inline-block">Template Name:</div> <br>
                            <div class="fw-500 text-secondary d-inline-block text-capitalize">
                                <span>
                                    {{general_details.ticket_template.name|| '-'}}
                                </span>
                            </div>
                        </div>
                    </div>
                    <div class="row pt-3 pl-5 pr-5 pb-2 bottom-border">
                        <div class="col-lg-6 col-md-12 col-sm-12">
                            <div class="fw-400 pt-2 pb-2 text-black d-inline-block">Template Type:</div> <br>
                            <div class="fw-500 text-secondary d-inline-block description-content">
                                <span v-if="general_details.ticket_template.template_type" class="text-capitalize" v-html="general_details.ticket_template.template_type.replace(/_/g, ' ')"></span>
                                <span v-else>-</span>
                            </div>
                        </div>
                    </div>
                    <div class="row pt-3 pl-5 pr-5 pb-2 bottom-border">
                        <div class="col-lg-12 col-md-12 col-sm-12">
                            <div class="fw-400 pt-2 pb-2 text-black d-inline-block">Description:</div> <br>
                            <div class="fw-500 text-secondary d-inline-block description-content">
                                <pre class="fs-14" v-if="general_details.description" v-html="general_details.description"></pre>
                                <span v-else>-</span>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="mt-5 mb-3">
                    <div class="box-blue-header d-flex align-items-center justify-content-between p-3 box-blue-header-parent">
                        <span class="text-white fw-500 pl-1">Ticket Details</span>
                        <span v-if="general_details.is_editable">
                            <img src="https://cdn.digicollect.com/cdn/dc_helpdesk_new/images/pencil_bg_white.svg" alt="" style="width: 25px;cursor:pointer" @click="showEditBaseTemplate()">
                        </span>
                    </div>
                    <div v-if="template_type == 'multi_part'">
                        <div class="details-checks" v-for="(part, part_index) in overall_templates" :key="part_index">
                            <div class="infoHeader">
                                <div class="descriptionheader px-2">
                                    <div class="description-text-header-left">
                                        <h5 class="font-weight-bold text-black whiteSpace text-capitalize">{{ part.part_name.split('').length > 1 ?  part.part_name[0].toUpperCase() +''+ part.part_name.slice(1,) : part.part_name[0].toUpperCase()}}</h5>
                                    </div>
                                    <div class="description-text-header-right">
                                        <!-- <span class="collapse-addon">
                                            <img src="https://cdn.digicollect.com/cdn/scmnew/images/main-collapse.svg" alt="" style="top: 9px !important">
                                        </span> -->
                                        <span class="collapse-addon" v-if="part.show">
                                            <img src="https://cdn.digicollect.com/cdn/scmnew/images/main-collapse.svg" @click="ToggleParts(part)" alt="" style="top: 9px !important;transition:0.5s">
                                        </span>
                                        <span class="collapse-addon" v-else>
                                            <img src="https://cdn.digicollect.com/cdn/scmnew/images/main-collapse.svg" alt="" @click="ToggleParts(part)" style="top: 9px !important;transform: rotate(180deg);transition:0.5s">
                                        </span>
                                    </div>
                                </div>
                            </div>
                            <div class="row pt-3 pl-5 pr-5 pb-2" v-if="part.show">
                                <span class="col-lg-6 col-md-6 col-sm-12 pb-2 bottom-border" v-for="(dynamic_data, index) in part.part_data" :key="index">
                                    <div class="fw-400 pt-2 pb-2 text-black d-inline-block w-100 text-capitalize overflowing-text" :title="dynamic_data.name">{{dynamic_data.name}}</div> <br>
                                    <div v-if="dynamic_data.type == 'long_answer'">
                                        <!-- <div class="fw-500 text-secondary d-inline-block">{{dynamic_data.answer || "-"}}</div> -->
                                        <div class="fw-500 text-secondary d-inline-block w-100 overflowing-text text-capitalize" :title="dynamic_data.answer">
                                        <span>{{dynamic_data.answer || '-'}}</span></div>
                                    </div>
                                    <div v-else-if="dynamic_data.type == 'short_answer'">
                                        <!-- <div class="fw-400 pt-2 pb-2 text-black d-inline-block w-100 overflowing-text" :title="dynamic_data.name">{{dynamic_data.name}}</div> <br> -->
                                        <!-- <div class="fw-500 text-secondary d-inline-block">{{dynamic_data.answer || "-"}}</div> -->
                                        <div class="fw-500 text-secondary d-inline-block w-100 overflowing-text text-capitalize" :title="dynamic_data.answer">
                                        <span>{{dynamic_data.answer || '-'}}</span></div>
                                    </div>
                                    <div v-else-if="dynamic_data.type == 'date'">
                                        <!-- <div class="fw-400 pt-2 pb-2 text-black d-inline-block w-100 overflowing-text" :title="dynamic_data.name">{{dynamic_data.name}}</div> <br> -->
                                        <span v-if="dynamic_data.answer.length == 0">-</span>
                                        <div v-else class="fw-500 text-secondary d-inline-block">
                                            <span><img src="https://cdn.digicollect.com/cdn/dc_helpdesk_new/images/images-new/menu/calendar.svg" alt=""></span>
                                            {{dynamic_data.answer}}</div>
                                    </div>
                                    <div v-else-if="dynamic_data.type == 'time'">
                                        <!-- <div class="fw-400 pt-2 pb-2 text-black d-inline-block w-100 overflowing-text" :title="dynamic_data.name">{{dynamic_data.name}}</div> <br> -->
                                        <span v-if="dynamic_data.answer.length == 0">-</span>
                                        <div v-else class="fw-500 text-secondary d-inline-block">
                                            <span><img src="https://cdn.digicollect.com/cdn/dc_helpdesk_new/images/images-new/menu/clock.svg" alt=""></span>
                                            {{dynamic_data.answer}}</div>
                                    </div>
                                    <div v-else-if="dynamic_data.type == 'radio_button'">
                                        <!-- <div class="fw-400 pt-2 pb-2 text-black d-inline-block w-100 overflowing-text" :title="dynamic_data.name">{{dynamic_data.name}}</div> <br> -->
                                        <!-- <div class="fw-500 text-secondary d-inline-block">{{dynamic_data.answer || "-"}}</div> -->
                                        <div class="fw-500 text-secondary d-inline-block w-100 overflowing-text text-capitalize" :title="dynamic_data.answer">
                                        <span v-if="dynamic_data.answer.length == 0">-</span>
                                        <span v-else>{{dynamic_data.answer}}</span></div>
                                    </div>
                                    <div v-else-if="dynamic_data.type == 'drop_down' && dynamic_data.is_api_call_required == false">
                                        <!-- <div class="fw-400 pt-2 pb-2 text-black d-inline-block w-100 overflowing-text" :title="dynamic_data.name">{{dynamic_data.name}}</div> <br> -->
                                        <!-- <div class="fw-500 text-secondary d-inline-block">{{dynamic_data.answer || "-"}}</div> -->
                                        <div class="fw-500 text-secondary d-inline-block w-100 overflowing-text" :title="dynamic_data.answer">
                                        <span class="text-capitalize">{{dynamic_data.answer || '-'}}</span></div>
                                    </div>
                                    <div v-else-if="dynamic_data.type == 'drop_down' && dynamic_data.is_api_call_required == true">
                                        <!-- <div class="fw-400 pt-2 pb-2 text-black d-inline-block w-100 overflowing-text" :title="dynamic_data.name">{{dynamic_data.name}}</div> <br> -->
                                        <!-- <div class="fw-500 text-secondary d-inline-block">{{dynamic_data.answer.name || "-"}}</div> -->
                                        <div class="fw-500 text-secondary d-inline-block w-100 overflowing-text" :title="dynamic_data.answer.name">
                                        <span class="text-capitalize">{{dynamic_data.answer.name || '-'}}</span></div>
                                    </div>
                                    <div v-else-if="dynamic_data.type == 'check_box'">
                                        <!-- <div class="fw-400 pt-2 pb-2 text-black d-inline-block w-100 overflowing-text" :title="dynamic_data.name">{{dynamic_data.name}}</div> <br> -->
                                        <span v-if="dynamic_data.answer.length == 0">-</span>
                                        <div v-else class="fw-500 text-secondary d-inline-block text-capitalize" v-for="(data, index) in dynamic_data.answer" :key='index'>{{data}}<span v-if="dynamic_data.answer.length > 1 && index < dynamic_data.answer.length - 1">,&nbsp;</span></div>
                                    </div>
                                    <div v-else-if="dynamic_data.type == 'tag'">
                                        <!-- <div class="fw-400 pt-2 pb-2 text-black d-inline-block w-100 overflowing-text" :title="dynamic_data.name">{{dynamic_data.name}}</div> <br> -->
                                        <div v-if="dynamic_data.answer.length == 0">-</div>
                                        <div v-else class="fw-500 text-secondary d-inline-block text-capitalize" v-for="(tag_name, index) in dynamic_data.answer" :key='index'>{{tag_name.hasOwnProperty('text') ? tag_name.text : tag_name}}<span v-if="dynamic_data.answer.length > 1 && index < dynamic_data.answer.length - 1">,&nbsp;</span></div>
                                    </div>
                                    <div v-else-if="dynamic_data.type == 'date_time'">
                                        <!-- <span v-if="dynamic_data.answer.length == 0">-</span> -->
                                        <div class="fw-500 text-secondary d-inline-block">
                                            <span><img src="https://cdn.digicollect.com/cdn/dc_helpdesk_new/images/images-new/menu/calendar.svg" alt=""></span>
                                            {{dynamic_data.answer.slice(0, 10)}}
                                            <span class="ml-2"><img src="https://cdn.digicollect.com/cdn/dc_helpdesk_new/images/images-new/menu/clock.svg" alt=""></span>
                                            {{dynamic_data.answer.slice(11, )}}
                                        </div>
                                    </div>
                                    <div v-else-if="dynamic_data.type == 'location'">
                                        <!-- <div class="fw-400 pt-2 pb-2 text-black d-inline-block w-100 overflowing-text" :title="dynamic_data.name">{{dynamic_data.name}}</div> <br> -->
                                        <!-- <div class="fw-500 text-secondary d-inline-block">{{dynamic_data.answer || "-"}}</div> -->
                                        <div class="fw-500 text-secondary d-inline-block w-100 overflowing-text text-capitalize" :title="dynamic_data.answer">
                                        <span>{{dynamic_data.answer || '-'}}</span></div>
                                    </div>
                                    <div class="mt-3" v-if="dynamic_data.hasOwnProperty('add_attachments') && dynamic_data.add_attachments">
                                        <div v-if="dynamic_data.hasOwnProperty('attachments')">
                                            <div v-if="dynamic_data.attachments.length == 0">
                                                <div class="fw-500 fs-15px mt-3">Attachment</div>
                                                <div class="font-weight-bold fs-15px mt-2">No Attachment Added</div>
                                            </div>
                                            <div v-else class="mt-3">
                                                <span class="fw-500 fs-15px">Attachment</span>
                                                <div v-for="(attachment, att_index) in dynamic_data.attachments" :key="att_index">
                                                    <div class="d-flex flex-wrap col-flex-sm">
                                                        <div class="d-flex justify-content-between align-items-center w-50 w-sm-100">
                                                            <div class="d-flex align-items-center" v-if="attachment.hasOwnProperty('url')">
                                                                <span  class="_images" @click="previewImage(attachment)">
                                                                    <img class="att-img pointer" v-if="attachment.url.endsWith('.pdf')"
                                                                        src="https://cdn.digicollect.com/cdn/scmnew/images/scm/pdf-attachment.svg" />
                                                                    <img class="att-img pointer" v-else-if="attachment.url.endsWith('.zip') || attachment.url.endsWith('.ZIP')" 
                                                                        src="https://cdn.digicollect.com/cdn/dc_helpdesk_new/images/zip-icon.svg">
                                                                    <img class="att-img pointer" v-else-if="attachment.url.endsWith('.csv') || attachment.url.endsWith('.CSV')" 
                                                                        src="https://cdn.digicollect.com/cdn/dc_helpdesk_new/images/csv_logo.svg">
                                                                    <img class="att-img pointer" v-else-if="attachment.url.endsWith('.ODS') || attachment.url.endsWith('.ods')" 
                                                                        src="https://cdn.digicollect.com/cdn/dc_helpdesk_new/images/ods_logo.svg">
                                                                    <img class="att-img pointer" v-else-if="attachment.url.endsWith('.svg')"
                                                                        src="https://cdn.digicollect.com/cdn/scmnew/images/scm/svg-icon.svg" />
                                                                    <img class="att-img pointer" v-else-if="attachment.url.endsWith('.xls') || attachment.name.endsWith('.xlsx')"
                                                                        src="https://cdn.digicollect.com/cdn/scmnew/images/scm/xls.svg" />
                                                                    <img class="att-img pointer" v-else-if="attachment.url.endsWith('.doc') || attachment.name.endsWith('.docx')"
                                                                        src="https://cdn.digicollect.com/cdn/scmnew/images/scm/docx.svg" />
                                                                    <img class="att-img pointer" v-else-if="attachment.url.endsWith('.avi') || attachment.name.endsWith('.flv') || attachment.name.endsWith('.mpg') || attachment.name.endsWith('.mpeg') || attachment.name.endsWith('.mp4') || attachment.name.endsWith('.wav') || attachment.name.endsWith('.wmv') || attachment.name.endsWith('.MOV') || attachment.name.endsWith('.mov')"
                                                                        src="https://cdn.digicollect.com/cdn/dc_helpdesk_new/images/default_video.svg" />
                                                                    <img class="att-img pointer" v-else :src="attachment.url" alt="">
                                                                </span>
                                                                <div class="fw-500 d-inline-block overflowing-text attachment_name text-capitalize" :title="attachment.name">{{attachment.name}}</div>
                                                            </div>
                                                            <div v-else>
                                                                -
                                                            </div>
                                                            <div v-if="attachment.hasOwnProperty('url')">
                                                                <a class="pointer" :href="attachment.url" download style="text-decoration: none;">
                                                                    <i class="icon icon-download"></i>
                                                                </a>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </span>
                            </div>
                            <div class="mt-5 mb-3" v-if="part.attach_files.length > 0 && part.show">
                                <div class="infoHeader">
                                    <div class="descriptionheader px-2">
                                        <div class="description-text-header-left">
                                            <h5 class="font-weight-bold text-black whiteSpace">Attachments</h5>
                                        </div>
                                        <div class="description-text-header-right">
                                            <!-- <span class="collapse-addon" v-if="part.show">
                                                <img src="https://cdn.digicollect.com/cdn/scmnew/images/main-collapse.svg" @click="ToggleParts(part)" alt="" style="top: 9px !important;transition:0.5s">
                                            </span>
                                            <span class="collapse-addon" v-else>
                                                <img src="https://cdn.digicollect.com/cdn/scmnew/images/main-collapse.svg" alt="" @click="ToggleParts(part)" style="top: 9px !important;transform: rotate(180deg);transition:0.5s">
                                            </span> -->
                                        </div>
                                    </div>
                                </div>
                                <div class="d-flex flex-wrap col-flex-sm">
                                    <div class="d-flex justify-content-between align-items-center px-3 w-50 w-sm-100" v-for="attachments in part.attach_files" :key="attachments.url">
                                        <div class="d-flex align-items-center" v-if="attachments.hasOwnProperty('url')">
                                            <span  class="_images" @click="previewImage(attachments)">
                                                <img class="att-img pointer" v-if="attachments.url.endsWith('.pdf')"
                                                    src="https://cdn.digicollect.com/cdn/scmnew/images/scm/pdf-attachment.svg" />
                                                <img class="att-img pointer" v-else-if="attachments.url.endsWith('.zip') || attachments.url.endsWith('.ZIP')" 
                                                    src="https://cdn.digicollect.com/cdn/dc_helpdesk_new/images/zip-icon.svg">
                                                <img class="att-img pointer" v-else-if="attachments.url.endsWith('.csv') || attachments.url.endsWith('.CSV')" 
                                                    src="https://cdn.digicollect.com/cdn/dc_helpdesk_new/images/csv_logo.svg">
                                                <img class="att-img pointer" v-else-if="attachments.url.endsWith('.ODS') || attachments.url.endsWith('.ods')" 
                                                    src="https://cdn.digicollect.com/cdn/dc_helpdesk_new/images/ods_logo.svg">
                                                <img class="att-img pointer" v-else-if="attachments.url.endsWith('.svg')"
                                                    src="https://cdn.digicollect.com/cdn/scmnew/images/scm/svg-icon.svg" />
                                                <img class="att-img pointer" v-else-if="attachments.url.endsWith('.xls') || attachments.name.endsWith('.xlsx')"
                                                    src="https://cdn.digicollect.com/cdn/scmnew/images/scm/xls.svg" />
                                                <img class="att-img pointer" v-else-if="attachments.url.endsWith('.doc') || attachments.name.endsWith('.docx')"
                                                    src="https://cdn.digicollect.com/cdn/scmnew/images/scm/docx.svg" />
                                                <img class="att-img pointer" v-else-if="attachments.url.endsWith('.avi') || attachments.name.endsWith('.flv') || attachments.name.endsWith('.mpg') || attachments.name.endsWith('.mpeg') || attachments.name.endsWith('.mp4') || attachments.name.endsWith('.wav') || attachments.name.endsWith('.wmv') || attachments.name.endsWith('.MOV') || attachments.name.endsWith('.mov')"
                                                    src="https://cdn.digicollect.com/cdn/dc_helpdesk_new/images/default_video.svg" />
                                                <img class="att-img pointer" v-else :src="attachments.url" alt="">
                                            </span>
                                            <div class="fw-500 d-inline-block overflowing-text attachment_name text-capitalize" :title="attachments.name">{{attachments.name}}</div>
                                        </div>
                                        <div v-else>
                                            -
                                        </div>
                                        <div v-if="attachments.hasOwnProperty('url')">
                                            <a class="pointer" :href="attachments.url" download style="text-decoration: none;">
                                                <i class="icon icon-download"></i>
                                            </a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="details-checks bg-lightgrey" v-for="(part, part_index) in remaining_templates" :key="part_index">
                            <div class="infoHeader">
                                <div class="descriptionheader px-2">
                                    <div class="description-text-header-left">
                                        <h5 class="font-weight-bold text-black whiteSpace text-capitalize">{{ part.part_name.split('').length > 1 ?  part.part_name[0].toUpperCase() +''+ part.part_name.slice(1,) : part.part_name[0].toUpperCase()}}</h5>
                                    </div>
                                    <div class="description-text-header-right">
                                        <!-- <span class="collapse-addon" v-if="part.show">
                                            <img src="https://cdn.digicollect.com/cdn/scmnew/images/main-collapse.svg" @click="ToggleParts(part)" alt="" style="top: 9px !important;transition:0.5s">
                                        </span>
                                        <span class="collapse-addon" v-else>
                                            <img src="https://cdn.digicollect.com/cdn/scmnew/images/main-collapse.svg" alt="" @click="ToggleParts(part)" style="top: 9px !important;transform: rotate(180deg);transition:0.5s">
                                        </span> -->
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="row pt-3 pl-5 pr-5 pb-2" v-if="template_type == 'default'">
                        <span class="col-lg-6 col-md-6 col-sm-12 pb-2 bottom-border" v-for="(dynamic_data, index) in dynamic_template_data" :key="index">
                            <div class="fw-400 pt-2 pb-2 text-black d-inline-block w-100 overflowing-text text-capitalize" :title="dynamic_data.name">{{dynamic_data.name}}</div> <br>
                            <div v-if="dynamic_data.type == 'long_answer'">
                                <div class="fw-500 text-secondary d-inline-block w-100 overflowing-text text-capitalize" :title="dynamic_data.answer">
                                <span>{{dynamic_data.answer || '-'}}</span></div>
                            </div>
                            <div v-else-if="dynamic_data.type == 'short_answer'">
                                <div class="fw-500 text-secondary d-inline-block w-100 overflowing-text text-capitalize" :title="dynamic_data.answer">
                                <span>{{dynamic_data.answer || '-'}}</span></div>
                            </div>
                            <div v-else-if="dynamic_data.type == 'date'">
                                <span v-if="dynamic_data.answer.length == 0">-</span>
                                <div v-else class="fw-500 text-secondary d-inline-block">
                                    <span><img src="https://cdn.digicollect.com/cdn/dc_helpdesk_new/images/images-new/menu/calendar.svg" alt=""></span>
                                    {{dynamic_data.answer}}</div>
                            </div>
                            <div v-else-if="dynamic_data.type == 'time'">
                                <span v-if="dynamic_data.answer.length == 0">-</span>
                                <div v-else class="fw-500 text-secondary d-inline-block">
                                    <span><img src="https://cdn.digicollect.com/cdn/dc_helpdesk_new/images/images-new/menu/clock.svg" alt=""></span>
                                    {{dynamic_data.answer}}</div>
                            </div>
                            <div v-else-if="dynamic_data.type == 'radio_button'">
                                <div class="fw-500 text-secondary d-inline-block w-100 overflowing-text text-capitalize" :title="dynamic_data.answer">
                                <span v-if="dynamic_data.answer.length == 0">-</span>
                                <span class="text-capitalize" v-else>{{dynamic_data.answer}}</span></div>
                            </div>
                            <div v-else-if="dynamic_data.type == 'drop_down' && dynamic_data.is_api_call_required == false">
                                <div class="fw-500 text-secondary d-inline-block w-100 overflowing-text" :title="dynamic_data.answer">
                                <span class="text-capitalize">{{dynamic_data.answer || '-'}}</span></div>
                            </div>
                            <div v-else-if="dynamic_data.type == 'drop_down' && dynamic_data.is_api_call_required == true">
                                <div class="fw-500 text-secondary d-inline-block w-100 overflowing-text" :title="dynamic_data.answer.name">
                                <span class="text-capitalize">{{dynamic_data.answer.name || '-'}}</span></div>
                            </div>
                            <div v-else-if="dynamic_data.type == 'check_box'">
                                <span v-if="dynamic_data.answer.length == 0">-</span>
                                <div v-else class="fw-500 text-secondary d-inline-block text-capitalize" v-for="(data, index) in dynamic_data.answer" :key='index'>{{data}}<span v-if="dynamic_data.answer.length > 1 && index < dynamic_data.answer.length - 1">,&nbsp;</span></div>
                            </div>
                            <div v-else-if="dynamic_data.type == 'tag'">
                                <div v-if="dynamic_data.answer.length == 0">-</div>
                                <div v-else class="fw-500 text-secondary d-inline-block text-captitalize" v-for="(tag_name, index) in dynamic_data.answer" :key='index'>{{tag_name}}<span v-if="dynamic_data.answer.length > 1 && index < dynamic_data.answer.length - 1">,&nbsp;</span></div>
                            </div>
                            <div v-else-if="dynamic_data.type == 'date_time'">
                                <div class="fw-500 text-secondary d-inline-block">
                                    <span><img src="https://cdn.digicollect.com/cdn/dc_helpdesk_new/images/images-new/menu/calendar.svg" alt=""></span>
                                    {{dynamic_data.answer.slice(0, 10)}}
                                    <span class="ml-2"><img src="https://cdn.digicollect.com/cdn/dc_helpdesk_new/images/images-new/menu/clock.svg" alt=""></span>
                                    {{dynamic_data.answer.slice(11, )}}
                                </div>
                            </div>
                            <div v-else-if="dynamic_data.type == 'location'">
                                <div class="fw-500 text-secondary d-inline-block w-100 overflowing-text" :title="dynamic_data.answer">
                                <span class="text-capitalize">{{dynamic_data.answer || '-'}}</span></div>
                            </div>
                            <div class="mt-3" v-if="dynamic_data.hasOwnProperty('add_attachments') && dynamic_data.add_attachments">
                                <div v-if="dynamic_data.hasOwnProperty('attachments')">
                                    <div v-if="dynamic_data.attachments.length == 0">
                                        <div class="fw-500 fs-15px mt-3">Attachment</div>
                                        <div class="font-weight-bold fs-15px mt-2">No Attachment Added</div>
                                    </div>
                                    <div v-else class="mt-3">
                                        <span class="fw-500 fs-15px">Attachment</span>
                                        <div v-for="(attachment, att_index) in dynamic_data.attachments" :key="att_index">
                                            <div class="d-flex flex-wrap col-flex-sm">
                                                <div class="d-flex justify-content-between align-items-center w-50 w-sm-100">
                                                    <div class="d-flex align-items-center" v-if="attachment.hasOwnProperty('url')">
                                                        <span  class="_images" @click="previewImage(attachment)">
                                                            <img class="att-img pointer" v-if="attachment.url.endsWith('.pdf')"
                                                                src="https://cdn.digicollect.com/cdn/scmnew/images/scm/pdf-attachment.svg" />
                                                            <img class="att-img pointer" v-else-if="attachment.url.endsWith('.zip') || attachment.url.endsWith('.ZIP')" 
                                                                src="https://cdn.digicollect.com/cdn/dc_helpdesk_new/images/zip-icon.svg">
                                                            <img class="att-img pointer" v-else-if="attachment.url.endsWith('.csv') || attachment.url.endsWith('.CSV')" 
                                                                src="https://cdn.digicollect.com/cdn/dc_helpdesk_new/images/csv_logo.svg">
                                                            <img class="att-img pointer" v-else-if="attachment.url.endsWith('.ODS') || attachment.url.endsWith('.ods')" 
                                                                src="https://cdn.digicollect.com/cdn/dc_helpdesk_new/images/ods_logo.svg">
                                                            <img class="att-img pointer" v-else-if="attachment.url.endsWith('.svg')"
                                                                src="https://cdn.digicollect.com/cdn/scmnew/images/scm/svg-icon.svg" />
                                                            <img class="att-img pointer" v-else-if="attachment.url.endsWith('.xls') || attachment.name.endsWith('.xlsx')"
                                                                src="https://cdn.digicollect.com/cdn/scmnew/images/scm/xls.svg" />
                                                            <img class="att-img pointer" v-else-if="attachment.url.endsWith('.doc') || attachment.name.endsWith('.docx')"
                                                                src="https://cdn.digicollect.com/cdn/scmnew/images/scm/docx.svg" />
                                                            <img class="att-img pointer" v-else-if="attachment.url.endsWith('.avi') || attachment.name.endsWith('.flv') || attachment.name.endsWith('.mpg') || attachment.name.endsWith('.mpeg') || attachment.name.endsWith('.mp4') || attachment.name.endsWith('.wav') || attachment.name.endsWith('.wmv') || attachment.name.endsWith('.MOV') || attachment.name.endsWith('.mov')"
                                                                src="https://cdn.digicollect.com/cdn/dc_helpdesk_new/images/default_video.svg" />
                                                            <img class="att-img pointer" v-else :src="attachment.url" alt="">
                                                        </span>
                                                        <div class="fw-500 d-inline-block overflowing-text attachment_name text-capitalize" :title="attachment.name">{{attachment.name}}</div>
                                                    </div>
                                                    <div v-else>
                                                        -
                                                    </div>
                                                    <div v-if="attachment.hasOwnProperty('url')">
                                                        <a class="pointer" :href="attachment.url" download style="text-decoration: none;">
                                                            <i class="icon icon-download"></i>
                                                        </a>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </span>
                    </div>
                </div>
                <div class="mt-5 mb-3" v-if="general_details.attach_files.length > 0">
                    <div class="box-blue-header d-flex align-items-center justify-content-between p-3 box-blue-header-parent">
                        <span class="text-white fw-500 pl-1">Attachments</span>
                        <span v-if="general_details.is_editable">
                            <img src="https://cdn.digicollect.com/cdn/dc_helpdesk_new/images/pencil_bg_white.svg" alt="" style="width: 25px;cursor:pointer" @click="showEditBaseTemplate()">
                        </span>
                    </div>
                    <div class="d-flex flex-wrap col-flex-sm">
                        <div class="d-flex justify-content-between align-items-center px-3 w-50 w-sm-100" v-for="attachments in general_details.attach_files" :key="attachments.url">
                            <div class="d-flex align-items-center" v-if="attachments.hasOwnProperty('url')">
                                <span  class="_images" @click="previewImage(attachments)">
                                    <img class="att-img pointer" v-if="attachments.url.endsWith('.pdf')"
                                        src="https://cdn.digicollect.com/cdn/scmnew/images/scm/pdf-attachment.svg" />
                                    <img class="att-img pointer" v-else-if="attachments.url.endsWith('.zip') || attachments.url.endsWith('.ZIP')" 
                                        src="https://cdn.digicollect.com/cdn/dc_helpdesk_new/images/zip-icon.svg">
                                    <img class="att-img pointer" v-else-if="attachments.url.endsWith('.csv') || attachments.url.endsWith('.CSV')" 
                                        src="https://cdn.digicollect.com/cdn/dc_helpdesk_new/images/csv_logo.svg">
                                    <img class="att-img pointer" v-else-if="attachments.url.endsWith('.ODS') || attachments.url.endsWith('.ods')" 
                                        src="https://cdn.digicollect.com/cdn/dc_helpdesk_new/images/ods_logo.svg">
                                    <img class="att-img pointer" v-else-if="attachments.url.endsWith('.svg')"
                                        src="https://cdn.digicollect.com/cdn/scmnew/images/scm/svg-icon.svg" />
                                    <img class="att-img pointer" v-else-if="attachments.url.endsWith('.xls') || attachments.name.endsWith('.xlsx')"
                                        src="https://cdn.digicollect.com/cdn/scmnew/images/scm/xls.svg" />
                                    <img class="att-img pointer" v-else-if="attachments.url.endsWith('.doc') || attachments.name.endsWith('.docx')"
                                        src="https://cdn.digicollect.com/cdn/scmnew/images/scm/docx.svg" />
                                    <img class="att-img pointer" v-else-if="attachments.url.endsWith('.avi') || attachments.name.endsWith('.flv') || attachments.name.endsWith('.mpg') || attachments.name.endsWith('.mpeg') || attachments.name.endsWith('.mp4') || attachments.name.endsWith('.wav') || attachments.name.endsWith('.wmv') || attachments.name.endsWith('.MOV') || attachments.name.endsWith('.mov')"
                                        src="https://cdn.digicollect.com/cdn/dc_helpdesk_new/images/default_video.svg" />
                                    <img class="att-img pointer" v-else :src="attachments.url" alt="">
                                </span>
                                <div class="fw-500 d-inline-block overflowing-text attachment_name text-capitalize" :title="attachments.name">{{attachments.name}}</div>
                            </div>
                            <div v-else>
                                -
                            </div>
                            <div v-if="attachments.hasOwnProperty('url')">
                                <a class="pointer" :href="attachments.url" download style="text-decoration: none;">
                                    <i class="icon icon-download"></i>
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="d-flex justify-content-center align-items-center my-8" v-if="general_details.status == 'Closed' && general_details.ticket_template.template_type != 'multi_part'">
                    <button style="text-transform: capitalize;" disabled class="btn btn-success text-white btn-width" @click="generateNewReport">
                        Generate Report
                    </button>
                </div>
            </div>
        </div>
        <change-status @updateStatus="updateStatus()" :template_type="general_details.ticket_template.template_type" @cancelStatus="cancelStatus" v-if="showChange" modal_name="status-change" :ticket_id="ticket_id" :customer_name="customer_name" :status="newStatus" :closed_ticket="closed_ticket"></change-status>
        <edit-base-template modal_name="edit-base-template" v-if="editBase" @hideEditBase="hideEditBase" :ticket_id="ticket_id" @saveEditBase="getDetails()"></edit-base-template>
        <edit-software-bug-template modal_name="edit-software-bug-modal" v-if="editSBR" :ticket_id="ticket_id" :template_id="template_id" @hideSBR="hideSBR" @saveEditSBR="getDetails()"></edit-software-bug-template>
        <ticket-access modal_name="ticket-access" :reasonTicketAccess="reasonTicketAccess"></ticket-access>
        <generate-report modal_name="generate-report" v-if="show_generate_report" :ticket_id="ticket_id" @hideGenerateReport="hideGenerateReport"></generate-report>
        <sweet-modal ref="success_modal" icon="success">{{success_msg}}</sweet-modal>
        <sweet-modal ref="warning_modal" icon="warning">{{warning_msg}}</sweet-modal>
    </div>
</template>
<script>
import ticket from '../mixins/ticket.js';
import convert from '../mixins/convert.js';
import { EventBus } from '../eventBus/nav-bar-event.js';
// import VueTagsInput from '@johmun/vue-tags-input'
const ChangeStatus = () => import("./ChangeStatus");
const EditBaseTemplate = () => import("./EditBaseTemplate");
const TicketAccess = () => import("./AccessTicket");
const EditSoftwareBugTemplate = () => import("./EditSoftwareBugTemplate");
const GenerateReport = () => import("./GenerateReport");
import { SweetModal } from 'sweet-modal-vue';
import setting from '../mixins/setting.js';
export default {
    mixins:[ticket,convert, setting],
    components:{
        ChangeStatus,
        EditBaseTemplate,
        SweetModal,
        TicketAccess,
        EditSoftwareBugTemplate,
        GenerateReport
        // VueTagsInput
    },
    props:['ticket_id'],
    data(){
        return{
            ajaxCallinprogress: false,
            show_generate_report: false,
            success_msg:'',
            warning_msg:'',
            general_details:'',
            template_data:'',
            get_template: null,
            dynamic_template_data: [],
            template_data_SBR:'',
            visible:false,
            attachments:[],
            generic_attachments:[],
            image_attachments:[],
            audio_video_attachments:[],
            showChange:false,
            newStatus:'',
            customer_id:'',
            editBase:false,
            aggregate_costing:'',
            template_id:'',
            editSBR:false,
            reasonTicketAccess:'',
            product_id:'',
            isSBR:false,
            tags:{},
            dialogImageUrl: '',
            dialogVisible: false,
            addSP: false,
            customer_name:'',
            preview_visible:false,
            preview_file:{},
            preview_acc_id:'',
            show_priority: false,
            is_software_bug_template: '',
            template_name: '',
            overall_templates: [],
            remaining_templates: [],
            can_edit: false,
            can_change_status: true,
            can_close_ticket: false,
            is_ticket_details_not_found: false,
            check_if_approval_required: false
        }
    },
    methods:{
        ToggleParts(part){
            if(part.show){
                    part.show = false
            } else {
                    part.show = true
            }
            this.$forceUpdate()
        },
        previewImage(file) {
            this.$emit('previewImage', file)
        },
        previewImageTicketFix(file) {
            if(file) {
                let fileName = file.split('/');
                let file1 = {
                    url: file,
                    name: fileName[fileName.length-1],
                }
                this.$emit('previewImageTicketFix', file1)
            }
        },
        generateNewReport() {
            this.show_generate_report = true;
            setTimeout(() => {
                this.$modal.show('generate-report');
            }, 500);
        },
        hideGenerateReport() {
            this.show_generate_report = false;
        },
        hideSBR(){
            this.editSBR = false
        },
        cancelStatus(){
            this.showChange = false
        },
        updateStatus(){
            this.showChange = false;
            this.getDetails();
        },
        showAllStatus(){
            this.newStatus = this.general_details.status
            this.showChange = true
            setTimeout(() => {
                this.$modal.show('status-change');
            }, 500);
        },
        hideEditBase(){
           this.editBase = false
        },
        async showEditBaseTemplate(){
            this.$router.push(
                {
                    path: "/ticketdetails/edit/" + this.ticket_id
                }
            );
        },
        async showEditSoftwareBugModal(){
            try {
                let params = {
                    ticket_id:this.ticket_id
                }
                let res = await this.setEditDetails(params)
                this.editSBR = true
                this.template_id = this.template_data_SBR.template_id
                // this.ticket_id = value.ticket_id
                setTimeout(() => {
                    this.$modal.show('edit-software-bug-modal');
                }, 500);
            } catch (reason) {
                this.reasonTicketAccess = reason
                setTimeout(() => {
                    this.$modal.show('ticket-access');
                }, 500);
            }
        },
        distinctAttachments(){
            this.generic_attachments = []
            this.image_attachments = []
            this.audio_video_attachments = []
            if(this.attachments.hasOwnProperty('url')){
                this.attachments.forEach((el,index)=>{
                    if(el.url.endsWith('.doc') || el.url.endsWith('.docx') || el.url.endsWith('.htm') || el.url.endsWith('.html') || el.url.endsWith('.pdf') || el.url.endsWith('.ppt') || el.url.endsWith('.pptx') || el.url.endsWith('.txt') || el.url.endsWith('.xls') || el.url.endsWith('.xlsx')){
                    this.generic_attachments.push(el)
                    }else if(el.url.endsWith('.png') || el.url.endsWith('.PNG') || el.url.endsWith('.jpg') || el.url.endsWith('.JPG') || el.url.endsWith('.svg') || el.url.endsWith('.bmp') || el.url.endsWith('.BMP') || el.url.endsWith('.jpeg') || el.url.endsWith('.JPEG') || el.url.endsWith('.gif') || el.url.endsWith('.tiff')){
                    this.image_attachments.push(el)
                    }else if(el.url.endsWith('.avi') || el.url.endsWith('.flv') || el.url.endsWith('.mpg') || el.url.endsWith('.mpeg') || el.url.endsWith('.mp3') || el.url.endsWith('.mp4') || el.url.endsWith('.wav') || el.url.endsWith('.wmv')){
                    this.audio_video_attachments.push(el)
                    }
                })
            }
        },
        async getDetails(){
            try {
                this.overall_templates = []
                this.ajaxCallinprogress = true;
                let params ={
                    ticket_id:this.ticket_id || this.$route.params.id
                }
                let res = await this.getTicketById(params)
                this.is_ticket_details_not_found = false;
                this.ajaxCallinprogress = false;
                this.general_details = res.response.general_details
                this.template_name = this.general_details.ticket_template.name
                this.template_type = this.general_details.ticket_template.template_type
                this.can_edit = res.response.can_edit
                if(this.template_type == 'default'){
                    this.dynamic_template_data = res.response.template_data[this.template_name]
                    this.template_data = res.response.template_data;
                    this.attachments = this.general_details.attach_files || []
                    this.dynamic_template_data.forEach((el) => {
                        if(el.add_attachments && !el.hasOwnProperty('attachments')){
                            el.attachments = []
                        }
                    })
                } else {
                    if(res.response.hasOwnProperty('template_data')){
                        // this.approved_templates = res.response.template_data
                        // this.approved_templates.forEach((e) => {
                        //     e.show = true
                        //     e.part_data.forEach((pd) => {
                        //         if(pd.add_attachments && !pd.hasOwnProperty('attachments')){
                        //             pd.attachments = []
                        //         }
                        //     })
                        // })
                        res.response.template_data.forEach((e) => {
                            e.show = true
                            e.part_data.forEach((pd) => {
                                if(pd.add_attachments && !pd.hasOwnProperty('attachments')){
                                    pd.attachments = []
                                }
                            })
                            if(e.part_data.length > 0) this.overall_templates.push(e);
                        })
                    } else {
                        this.check_if_approval_required = true
                        this.can_close_ticket = res.response.can_save
                        // this.approved_templates = res.response.approved_part_details
                        // this.approved_templates.forEach((e) => {
                        //     e.show = true
                        //     e.part_data.forEach((pd) => {
                        //         if(pd.add_attachments && !pd.hasOwnProperty('attachments')){
                        //             pd.attachments = []
                        //         }
                        //     })
                        // })
                        res.response.approved_part_details.forEach((e) => {
                            e.show = true
                            e.part_data.forEach((pd) => {
                                if(pd.add_attachments && !pd.hasOwnProperty('attachments')){
                                    pd.attachments = []
                                }
                            })
                            if(e.part_data.length > 0) this.overall_templates.push(e);
                        })
                        res.response.pending_details.forEach((e) => {
                            e.show = true
                            e.part_data.forEach((pd) => {
                                if(pd.add_attachments && !pd.hasOwnProperty('attachments')){
                                    pd.attachments = []
                                }
                            })
                            if(e.part_data.length > 0) this.overall_templates.push(e);
                        })
                        // res.response.remaining_parts.forEach((e) => {
                        //     e.show = true
                        //     e.part_data.forEach((pd) => {
                        //         if(pd.add_attachments && !pd.hasOwnProperty('attachments')){
                        //             pd.attachments = []
                        //         }
                        //     })
                        //     if(e.part_data.length > 0) this.overall_templates.push(e);
                        // })
                        this.remaining_templates = res.response.remaining_parts
                        if(res.response.pending_details.length == 0){
                            this.can_change_status = false
                        }
                    }
                }
                // Dynamic template data
                this.customer_name = this.general_details.customer_name
                this.distinctAttachments()
            } catch (reason) {
                this.warning_msg = reason
                this.$refs.warning_modal.open();
                setTimeout(() => {
                    this.$refs.warning_modal.close();
                    this.ajaxCallinprogress = false;
                    this.is_ticket_details_not_found = true;
                }, 3000);
            }
        },
        async getDetailsById(id){
            try {
                this.overall_templates = []
                this.ajaxCallinprogress = true;
                let params ={
                    ticket_id:id
                }
                let res = await this.getTicketById(params)
                this.is_ticket_details_not_found = false;
                this.ajaxCallinprogress = false;
                this.general_details = res.response.general_details
                this.template_name = this.general_details.ticket_template.name
                this.template_type = this.general_details.ticket_template.template_type
                this.can_edit = res.response.can_edit
                if(this.template_type == 'default'){
                    this.dynamic_template_data = res.response.template_data[this.template_name]
                    this.template_data = res.response.template_data;
                    this.attachments = this.general_details.attach_files || []
                    this.dynamic_template_data.forEach((el) => {
                        if(el.add_attachments && !el.hasOwnProperty('attachments')){
                            el.attachments = []
                        }
                    })
                } else {
                    if(res.response.hasOwnProperty('template_data')){
                        // this.approved_templates = res.response.template_data
                        // this.approved_templates.forEach((e) => {
                        //     e.show = true
                        // })
                        res.response.template_data.forEach((e) => {
                            e.show = true
                            e.part_data.forEach((pd) => {
                                if(pd.add_attachments && !pd.hasOwnProperty('attachments')){
                                    pd.attachments = []
                                }
                            })
                            if(e.part_data.length > 0) this.overall_templates.push(e);
                        })
                    } else {
                        this.check_if_approval_required = true
                        this.can_close_ticket = res.response.can_save
                        // this.approved_templates = res.response.approved_part_details
                        // this.approved_templates.forEach((e) => {
                        //     e.show = true
                        // })
                        // this.approved_templates.forEach((e) => {
                        //     e.parts_data.forEach((pd) => {
                        //         if(pd.add_attachments && !pd.hasOwnProperty('attachments')){
                        //             pd.attachments = []
                        //         }
                        //     })
                        // })
                        res.response.approved_part_details.forEach((e) => {
                            e.show = true
                            e.part_data.forEach((pd) => {
                                if(pd.add_attachments && !pd.hasOwnProperty('attachments')){
                                    pd.attachments = []
                                }
                            })
                            if(e.part_data.length > 0) this.overall_templates.push(e);
                        })
                        res.response.pending_details.forEach((e) => {
                            e.show = true
                            e.part_data.forEach((pd) => {
                                if(pd.add_attachments && !pd.hasOwnProperty('attachments')){
                                    pd.attachments = []
                                }
                            })
                            if(e.part_data.length > 0) this.overall_templates.push(e);
                        })
                        res.response.remaining_parts.forEach((e) => {
                            e.show = true
                            e.part_data.forEach((pd) => {
                                if(pd.add_attachments && !pd.hasOwnProperty('attachments')){
                                    pd.attachments = []
                                }
                            })
                            if(e.part_data.length > 0) this.overall_templates.push(e);
                        })
                        if(res.response.pending_details.length == 0){
                            this.can_change_status = false
                        }
                    }
                }
                this.customer_name = this.general_details.customer_name
                this.distinctAttachments()
            } catch (reason) {
                this.warning_msg = reason
                this.$refs.warning_modal.open();
                setTimeout(() => {
                    this.$refs.warning_modal.close();
                    this.ajaxCallinprogress = false;
                    this.is_ticket_details_not_found = true;
                }, 3000);
            }
        },
        closeTicket(){
            this.$router.push({
                    path: `/ticketdetails/edit/${this.$route.params.id}`,
                    query: {
                        type: 'normal_ticket'
                    }
                }
            )
        },
        capitalize(string){
            return string[0].toUpperCase() + string.substring(1);
        },
        async getIsShowPriority() {
            let param = {
                settings_type: ['display_ticket_priorities']
            }
            let data = await this.getAllJobTypes(param);
            this.show_priority = data.response.display_ticket_priorities.display_ticket_priorities;
        },
        isSoftwareBugTemplate() {
            this.$emit('isSoftwareBugTemplate', this.is_software_bug_template);
        },
    },
    created(){
        // EventBus.$on('ReloadDetailsDataById', (id) => {
        //     this.getDetailsById(id)
        // })
    },
    async mounted(){
        // this.getIsShowPriority();
        if(!this.ticket_id) this.ticket_id = this.$route.params.id
        EventBus.$on('ticketFromFirebaseNotify',(data)=>{
            if(data.active_tab == 'ticket_details'){
                if(this.ticket_id) {
                    this.getDetails();
                }
            }
        })
        if(this.ticket_id) {
            this.getDetails();
        }
    },
    watch: {
        "$route.params": function (params) {
            if(params.id) {
                this.getDetails();
            }
        },
    },
    destroyed(){
        // EventBus.$off('ReloadDetailsDataById')
    },
    computed:{
        loggedInUser() {
            return this.$store.state.store.loggedInUser
        },
        showDept(){
           return this.$store.state.store.getGeneralSettings.display_department_section_in_base_template.display_department_section_in_base_template
        },
        getGeneralSettings(){
            return this.$store.state.store.getGeneralSettings
        },
        product_naming_convention(){
            if(this.getGeneralSettings && this.getGeneralSettings.naming_convention_of_products){
                return this.capitalize(this.getGeneralSettings.naming_convention_of_products.naming_convention_of_products)
            }else{
                return ''
            }
        },
        closed_ticket(){
            return{
                ticket_number:this.general_details.ticket_number,
                // company:this.general_details.customer_details.company_name,
                subject:this.general_details.subject,
                author_name:this.general_details.created_by.name,
                assigned_to:this.general_details.assigned_to,
                description:this.general_details.description,
                ticket_id:this.ticket_id
            }
        }
    }
}
</script>
<style scoped>
.btn-width{
    width: 150px !important;
}
.productBox{
    border: 1px solid #005dae;
    border-radius: 8px;
    padding: 10px 20px;
    margin: 15px 0;
    background: #FFF;
}
.warranty{
    padding: 5px 10px;
    border-radius: 10px;
    background-color:#2dc96f;
    color: #fff;
    font-size: 12px;
    font-weight: 600;
}
.out_warranty{
    padding: 5px 10px;
    border-radius: 10px;
    background-color:#f86c65;
    color: #fff;
    font-size: 12px;
    font-weight: 600;
}
.serviceBox{
    border: 1px solid #005dae;
    border-radius: 8px;
    padding: 10px 20px;
}
.borderBottomBlue{
    border: 0.5px solid #005dae;
}
.box-blue{
    background-color:  #00448b;
    border-radius: 18px;
    padding: 10px 20px;
}
.box-title{
    background-color: #ffffff;
    border-top-left-radius: 18px;
    border-top-right-radius: 18px;
}
.box-inside{
    background-color:  #ebf4fe;
    border-radius: 18px;
}
.rating{
    background-color: #ffffff;
    border-radius: 5px;
    text-align: center;
}
.signaturebg{
    background-color: #ffffff;
    width: 80%;
    border-radius: 5px;
    box-shadow: 0 1.5px 3px 0 rgba(0, 0, 0, 0.16);
    border: solid 0.3px #f5a623;
}
.ticket_subject{
    /* width: 250px;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden; */
    word-break: break-all;
}
.table-hover-none tbody tr:hover{
    -moz-box-shadow: none;
    -webkit-box-shadow: none;
    box-shadow: none;
    background-color: #fff !important;
}
.product-bg{
    background-color: #ffffff;
   border:1px solid #707070;
   padding: 5px;
   border-radius: 4px;
}
.product-bg-list{
   border-bottom:1px solid #005dae;
}
.tech-file-bg{
    background-color: #f7f8fa;
    border-radius: 4px;
    padding: 10px;
    height: 225px;
}
.rating-counts{
    background-color: #ffffff;
    border: 1px solid #ecf5ff;
    border-radius: 5px;
    min-height: 150px;
    padding: 5px;
    margin-top: 10px;
}
.box-blue-header{
    border-top-left-radius: 12px;
    border-top-right-radius: 12px;
}
.bottomBorder{
    border-bottom: 1px solid #005dae;
    padding-bottom: 5px;
}
.topBorder{
    border-top: 1px solid #005dae;
    padding-bottom: 5px;
}
.box-with-blue-border {
    border: 15px solid #005dae;
    border-left-width: 10px;
    border-right-width: 10px;
}
.box-blue-header-parent {
    background: #005dae;
    position: relative;
    top: -1px;
    margin-left: -1px;
}
.bottom-border{
    border-bottom: 1px solid #cce3fc;
}
._images{
	margin: 5px;
	padding: 5px;
	border-radius: 2.5px;
	box-shadow: 0 1.5px 3px 0 rgba(0, 0, 0, 0.2);
	background-color: #f6f8ff;
	width: 177px !important;
    height: 100px !important;
	display: flex;
	flex-direction: column;
}
._images>img{
    height: 90px;
}
.att-background{
    background-color: #F1F3F4;
    margin: 8px;
    border-radius: 8px;
}
.att-img{
    height: 80px;
}
.attachment_name{
    width: 380px;
}
.w-50{
    width: 50%
}
.description-content{
    /* word-break: break-all;
    white-space: pre-wrap;
    line-break: anywhere; */
    text-align: justify;
}
.details-checks{
    border: 1px solid #0f5dae;
    border-radius: 5px !important;
    padding: 10px;
    margin-top:10px;
    margin: 10px;
}
.infoHeader>.descriptionheader .description-text-header-right img{
    width: 23px;
}
.btn-danger{
    background-color: #f87a74;
}
.btn-success{
    background-color: #41ae5d;
}
.btn-success, .btn-danger{
    width:150px !important;
    text-transform: capitalize;
    font-weight: 500;
}
.bg-lightgrey{
    background-color: lightgrey !important;
}
@media screen and (max-width: 1250px) {
    .attachment_name{
        width: 265px;
    }
}
@media (min-width:768px) and (max-width: 1070px){
    .attachment_name{
        width: 150px;
    }
}
@media screen and (max-width: 768px) {
    .col-flex-sm{
        flex-direction: column;
    }
    .w-sm-100{
        width: 100% !important;
    }
}
</style>